import { createContext } from 'react';

/** True inside a region whose controls a disabled fieldset turns off, so help tooltips stay silent there. */
export const DisabledScopeContext = createContext(false);
